/**
 * CardSkeleton — Skeleton de cards em grid ou lista
 */
import { SkeletonBar } from './SkeletonBar';
import { T } from '../../styles/tokens';

interface CardSkeletonProps {
  count?: number;
  layout?: 'grid' | 'list';
  cols?: number;
}

export function CardSkeleton({ count = 3, layout = 'grid', cols = 3 }: CardSkeletonProps) {
  const style: any = {
    border: `1px solid ${T.border}`,
    borderRadius: T.radiusLg,
    padding: T.space5,
    background: T.bgCard,
  };

  const cards = Array.from({ length: count }).map((_, i) => (
    <div key={i} style={style}>
      <SkeletonBar width="60%" height={12} style={{ marginBottom: T.space3 }} />
      <SkeletonBar width="85%" height={14} style={{ marginBottom: 10 }} />
      <SkeletonBar width="45%" height={14} />
    </div>
  ));

  if (layout === 'list') {
    return <div style={{ display: 'flex', flexDirection: 'column', gap: T.space3 }}>{cards}</div>;
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: T.space3 }}>
      {cards}
    </div>
  );
}
